import React, { FC, useEffect, useState } from 'react';

import { LinearProgress } from '@mui/material';
import { DataGrid, GridCallbackDetails, GridRowSelectionModel } from '@mui/x-data-grid';

import styles from './AssociatedSensors.module.scss';
import { SensorModel } from 'pages/TimeseriesPage/SensorModel';
import { timeseriesColumns } from 'pages/TimeseriesPage/TimeseriesTable/TimeseriesTableDefinition';
import { TimeseriesCustomToolbar } from 'pages/TimeseriesPage/TimeseriesTable/TimeseriesCustomToolbar';
import { dataGridFocusStyles } from 'styles';


interface AssociatedSensorsProps {
  associatedSensors: SensorModel[];
  isLoading: boolean;
  onUnassociate: (selectedSensors: GridRowSelectionModel) => void;
}

const AssociatedSensors: FC<AssociatedSensorsProps> = (props: AssociatedSensorsProps) => {

  const [selectedSensors, setSelectedSensors] = useState<GridRowSelectionModel>([]);
  const [isUnassociateButtonDisabled, setIsUnassociateButtonDisabled] = useState(false);

  useEffect(() => {
    setIsUnassociateButtonDisabled(!selectedSensors.length);
  }, [selectedSensors]);

  const unassociateHandler = () => {
    props.onUnassociate(selectedSensors);
  };

  const toolbarProps = {
    tableTitle: 'Associated',
    button: {
      label: 'Unassociate',
      disabled: isUnassociateButtonDisabled,
      onClick: unassociateHandler,
    },
  }

  const rowSelectionChangeHandler = (rowSelectionModel: GridRowSelectionModel, details: GridCallbackDetails) => {
    setSelectedSensors(rowSelectionModel);
  };

  return (
    <div className={styles.AssociatedSensors} data-testid="AssociatedSensors">
      <DataGrid
        rows={props.associatedSensors}
        columns={timeseriesColumns}
        slots={{
          loadingOverlay: LinearProgress,
          toolbar: () => TimeseriesCustomToolbar(toolbarProps),
        }}
        loading={props.isLoading}
        className={`${styles.zIndex30} project-data-grid`}
        getRowId={row => row._id}
        checkboxSelection
        onRowSelectionModelChange={rowSelectionChangeHandler}
        sx={dataGridFocusStyles}
      />
    </div>
  );
}

export default AssociatedSensors;
